/**
 * Constants for Services & Workflows configuration.
 */

/**
 * Display order for services in the configuration UI.
 * Services not in this list appear at the end, sorted alphabetically.
 */
export const SERVICE_DISPLAY_ORDER = [
  'intake',
  'case_setup',
  'client_communication',
  'claims',
  'police_reports',
  'medical_records_and_treatment',
  'demands',
] as const;

export type ServiceName = (typeof SERVICE_DISPLAY_ORDER)[number];
